import React from 'react';
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES } from '../../i18n/languages';
import { pubPath, pubText, hasPublicTranslation } from '../../i18n/publicTranslation';
export const PublicLanguageLinks: React.FC = () => {
    const location = useLocation();
    const pagePath = hasPublicTranslation(location.pathname) ? location.pathname : '/';
    return <Box component="nav" aria-label={pubText('Language')} sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 4, fontSize: 13 }}>
  {Object.values(SUPPORTED_LANGUAGES).map(language => <Box key={language.code} component={Link} lang={language.code} hrefLang={language.code} to={pubPath(pagePath, language.code)} sx={{ color: 'rgba(255,255,255,.65)', textDecoration: 'none', '&:hover': { color: '#d8a363' } }}>{language.name}</Box>)}
 </Box>;
};
